import { hoursToMilliseconds } from "date-fns"

type TimeDetails = { hours: number; minutes: number }

const msToHoursAndMinutes = (ms: number): TimeDetails => {
  const totalMinutes = Math.ceil(ms / (1000 * 60))
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return { hours, minutes }
}

export const getDurationInHoursAndMinutes = (startTime?: Date, endTime?: Date): TimeDetails => {
  if (!startTime || !endTime) {
    return { hours: 0, minutes: 0 }
  }

  const diffInMs = endTime.getTime() - startTime.getTime()
  return msToHoursAndMinutes(diffInMs)
}

export const convertDecimalHoursToHoursAndMinutes = (decimalHours: number): TimeDetails => {
  const ms = isNaN(decimalHours) || decimalHours < 0 ? 0 : hoursToMilliseconds(decimalHours)
  return msToHoursAndMinutes(ms)
}

export const getHHmmFromDate = ({
  date,
  midnightAs24Hour = false,
  convertEndOfDayToMidnight,
}: GetHHmmFromDateFnArgs) => {
  const hours = String(date.getHours()).padStart(2, "0")
  const minutes = String(date.getMinutes()).padStart(2, "0")
  const rawHHmm = `${hours}:${minutes}`
  const HHmm = convertEndOfDayToMidnight && rawHHmm === "23:59" ? "00:00" : rawHHmm
  return midnightAs24Hour && HHmm === "00:00" ? "24:00" : HHmm
}

export const convertHHmmToDate = ({ HHmm, date }: ConvertHHmmToDateArgs): Date => {
  const [hours, minutes] = HHmm.split(":").map(Number)
  const parsedDate = new Date(date)
  parsedDate.setHours(hours, minutes, 0, 0)
  return parsedDate
}

export const convertHoursAndMinutesToDecimalHours = (hours: number, minutes: number): number => {
  if (isNaN(hours) || isNaN(minutes) || hours < 0 || minutes < 0) return 0
  if (minutes >= 60) {
    hours += Math.floor(minutes / 60)
    minutes = minutes % 60
  }
  return hours + minutes / 60
}

type GetHHmmFromDateFnArgs = {
  date: Date
  midnightAs24Hour?: boolean // If true, returns "24:00" instead of "00:00"
  convertEndOfDayToMidnight?: boolean // If true, converts "23:59" to "24:00"
}

type ConvertHHmmToDateArgs = {
  HHmm: string
  date: Date
}
